import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  Image,
  InputGroup,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import { MdEdit, MdOutlineBorderColor } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import swal from "sweetalert";
import ErrorLabel from "../../ErrorLabel/ErrorLabel";
import { userId } from "../../Utils/LocalStorage";
import iicon from "../../assets/i.svg";
import { existingEmail } from "../API/existing-email";
import { getMarketplaceApi } from "../API/marketplace-profile";
import Loader from "../Loader/Loader";
import { getMarketplaceUpdateApi } from "../API/marketplace-profile-update";
import { getForgotPswdCounter } from "../../Redux/ForgotpswdCounterSlice";
import { useDispatch } from "react-redux";

const Profile = () => {
  const [loading, setLoading] = useState(true);
  const [marketplaceData, setMarketplaceData] = useState({});
  const [input, setInput] = useState({
    marketplaceDesc: "",
    marketplaceDescFlag: false,
    transactionFee: "",
    TransactionFeeFlag: false,
  });
  const [errorDisplay, setErrorDisplay] = useState({
    marketplaceDescription: "",
    transactionFees: "",
    email: "",
  });
  const [isEdit, setIsEdit] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const mms_city_id = userId();

  const handleEdit = (e) => {
    e.preventDefault();
    setIsEdit(true);
  };

  const onMarketDescription = (e) => {
    let val = e.target.value;

    setInput((prev) => {
      return { ...prev, marketplaceDesc: val, marketplaceDescFlag: true };
    });

    if (val === "") {
      setErrorDisplay((prev) => {
        return {
          ...prev,
          marketplaceDescription:
            "Marketplace description should not be empty!",
        };
      });
    } else if (val.length === 300) {
      setErrorDisplay((prev) => {
        return {
          ...prev,
          marketplaceDescription: "Maximum character limit reached",
        };
      });
    } else if (val.length < 300) {
      setErrorDisplay((prev) => {
        return {
          ...prev,
          marketplaceDescription: "",
        };
      });
    }
  };

  const OnTransactionFee = (e) => {
    let val = e.target.value.replace(/^(\d{2})(\d)/, "$1.$2");

    setInput((ps) => {
      return {
        ...ps,
        transactionFee:
          val > 86
            ? 86
            : val < 0
            ? 0.0
            : val.length < 5
            ? val
            : val.toString().slice(0, 5),
        TransactionFeeFlag: true,
      };
    });
    if (!val || /^\d*\.?\d+$/.test(val) === false) {
      setErrorDisplay((prev) => ({
        ...prev,
        transactionFees: "Please type a valid input.",
      }));
      // MarketTransactionFee("");
    } else {
      setErrorDisplay((prev) => ({
        ...prev,
        transactionFees: "",
      }));
    }
  };

  const OnTransactionFeeKeyDown = (e) => {
    if (e.key === "-" || e.key === "+") {
      e.preventDefault();
    }
  };

  const updateEmailHandler = async () => {
    const data = {
      mms_city_id: parseInt(mms_city_id),
      existing_email: marketplaceData?.marketplace_email,
    };
    localStorage.setItem("Otp_email", marketplaceData?.marketplace_email);
    try {
      const Response = await existingEmail(data, () => {
        navigate("/");
      });
      if (Response.status === 200) {
        toast.dismiss();
        toast.clearWaitingQueue();
        toast.success(Response.message, {
          position: "top-center",
          width: "500px",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        dispatch(getForgotPswdCounter(Response.timer));
        navigate("/otp/update-email");
      } else {
        toast.error(Response.message ?? "Something went wrong.", {
          position: "top-center",
          width: "auto",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    } catch (error) {
      toast.error("Something went wrong.", {
        position: "top-center",
        width: "auto",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    var check = true;

    const data = {
      marketplace_id: parseInt(mms_city_id),
      marketplace_desc: input.marketplaceDesc
        ? input.marketplaceDesc
        : marketplaceData?.marketplace_desc,
      marketplace_transaction_fee: input.transactionFee
        ? input.transactionFee
        : marketplaceData?.marketplace_transaction_fee,
      marketplace_email: marketplaceData.marketplace_email,
    };

    if (input.marketplaceDescFlag && !input.marketplaceDesc) {
      setErrorDisplay((prev) => {
        return {
          ...prev,
          marketplaceDescription:
            "Marketplace description should not be empty!",
        };
      });
      check = false;
    }

    if (input.TransactionFeeFlag && input.transactionFee === "") {
      setErrorDisplay((prev) => ({
        ...prev,
        transactionFees: "Transaction fees should not be empty!",
      }));
      check = false;
    }

    if (check) {
      try {
        const Response = await getMarketplaceUpdateApi(data, () => {
          navigate("/");
        });
        if (Response.status === 200) {
          toast.dismiss();
          toast.clearWaitingQueue();
          toast.success(Response.message, {
            position: "top-center",
            width: "500px",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          setIsEdit(false);
        } else {
          toast.error(Response.message ?? "Something went wrong.", {
            position: "top-center",
            width: "auto",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          setIsEdit(true);
        }
      } catch (error) {
        toast.error("Something went wrong.", {
          position: "top-center",
          width: "auto",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setIsEdit(false);
      }
    } else {
      console.log("Some error occured");
    }
  };

  const getMarketplaceData = async () => {
    const data = {
      mms_city_id: parseInt(mms_city_id),
    };
    const marketplaceRes = await getMarketplaceApi(data, () => {
      navigate("/");
    });

    if (marketplaceRes.status === 200) {
      setMarketplaceData(marketplaceRes?.data[0]);
      setLoading(false);
    } else {
      setMarketplaceData({});
      setLoading(false);
    }
  };

  const CancelHandler = () => {
    setInput((prev) => ({
      ...prev,
      marketplaceDesc: marketplaceData.marketplace_desc,
      transactionFee: marketplaceData.marketplace_transaction_fee,
    }));
    setIsEdit(false);
    setErrorDisplay((prev) => ({
      ...prev,
      marketplaceDescription: "",
      transactionFees: "",
    }));
  };

  useEffect(() => {
    getMarketplaceData();
  }, []);

  return (
    <>
      {loading ? <Loader /> : ""}
      <Form className="formmain mx-0 mt-4 signin-row profile-form pb-4">
        <Row className="items-center flex-col gap-2">
          <Col xs={12} sm={6} md={6} lg={6} className="justify-end">
            <button
              variant="primary"
              className="create-btn export-btn-main gap-1"
              style={{ fontSize: 17 }}
              onClick={!isEdit ? handleEdit : submitHandler}
            >
              {isEdit ? (
                "Save"
              ) : (
                <>
                  <MdEdit height={20} width={20} />
                  Edit
                </>
              )}
            </button>
          </Col>
          <Col xs={12} sm={6} md={6} lg={6} className="InputFields">
            <Form.Group controlId="formBasicEmail">
              <Form.Label className="form-label-custom">
                Marketplace Name
              </Form.Label>

              <InputGroup className="edit-border">
                <Form.Control
                  type="text"
                  placeholder="Enter Marketplace Name"
                  className="custom-formcontrol form-control bg-disabled"
                  autoComplete="off"
                  value={marketplaceData.marketplace_name}
                  disabled
                />
              </InputGroup>
              <ErrorLabel ErrorDisplay="" />
            </Form.Group>
          </Col>
          <Col xs={12} sm={6} md={6} lg={6} className="InputFields">
            <Form.Group controlId="formBasicEmail">
              <Form.Label className="form-label-custom">
                Marketplace Description<span className="star-required"> *</span>
                <OverlayTrigger
                  overlay={
                    <Tooltip
                      className="M_Desc_tooltip"
                      style={{ opacity: "1" }}
                    >
                      This is the description about the marketplace that
                      business users will see before subscribing for the
                      marketplace.
                    </Tooltip>
                  }
                >
                  <Image
                    loading="lazy"
                    src={iicon}
                    className="TTip"
                    width={20}
                  ></Image>
                </OverlayTrigger>
              </Form.Label>

              <InputGroup className="edit-border">
                <Form.Control
                  as="textarea"
                  name="w3review"
                  rows="4"
                  placeholder="Marketplace Description"
                  maxLength={300}
                  value={
                    input.marketplaceDescFlag === true
                      ? input.marketplaceDesc
                      : marketplaceData.marketplace_desc
                  }
                  autoComplete="off"
                  onChange={isEdit && onMarketDescription}
                  className={!isEdit && "disabled bg-disabled"}
                  disabled={!isEdit}
                />
              </InputGroup>
            </Form.Group>
            <ErrorLabel
              ErrorDisplay={errorDisplay.marketplaceDescription ?? ""}
            />
          </Col>
          <Col xs={12} sm={6} md={6} lg={6} className="InputFields">
            <Form.Group controlId="formBasicEmail">
              <Form.Label className="form-label-custom">
                Transaction Fee (%) <span className="star-required">*</span>
              </Form.Label>
              <InputGroup className="edit-border">
                <Form.Control
                  type="number"
                  placeholder="Transaction Fee"
                  maxLength={4}
                  value={
                    input.TransactionFeeFlag === true
                      ? input.transactionFee
                      : marketplaceData.transactionFee === ""
                      ? 0
                      : marketplaceData.marketplace_transaction_fee
                  }
                  min={0}
                  max={86}
                  step="0.01"
                  autoComplete="off"
                  onChange={isEdit && OnTransactionFee}
                  className={!isEdit && "disabled bg-disabled"}
                  onKeyDown={OnTransactionFeeKeyDown}
                  disabled={!isEdit}
                />
              </InputGroup>
            </Form.Group>
            <ErrorLabel ErrorDisplay={errorDisplay.transactionFees ?? ""} />
          </Col>
          <Col xs={12} sm={6} md={6} lg={6} className="InputFields">
            <Form.Group controlId="formBasicEmail">
              <Form.Label className="form-label-custom">
                Email <span className="star-required">*</span>
              </Form.Label>
              <InputGroup className="edit-border position-relative">
                <Form.Control
                  type="email"
                  placeholder="Enter Email"
                  className={`custom-formcontrol form-control ${
                    isEdit ? "pointer-events-none" : "disabled bg-disabled"
                  }`}
                  disabled={!isEdit}
                  autoComplete="off"
                  value={marketplaceData.marketplace_email}
                />
                {isEdit && (
                  <span onClick={updateEmailHandler} className="edit-icon-div">
                    <MdOutlineBorderColor />
                  </span>
                )}
              </InputGroup>
            </Form.Group>
          </Col>
          <div className="justify-center gap-2 mt-4">
            <Button onClick={CancelHandler} className="view">
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={submitHandler}
              className="orange-btn"
              disabled={!isEdit}
            >
              Save
            </Button>
          </div>
        </Row>
      </Form>
    </>
  );
};

export default Profile;
